import { Form } from "@4uhub/lib4uhub";
import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Paper } from "@mui/material";
import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { LanguageChangeNoAuth } from "../../components/UI/LanguageChangeNoAuth/LanguageChangeNoAuth";
import { PlatformFooter } from "../../components/UI/PlatformFooter/PlatformFooter";
import useFetch from "../../hooks/useFetch";
import { saveTotemDevice } from "../../services/totemDevide.service";
import { loginTotem } from "../../services/totemStart.service";
import { ITotemStartColors } from "./models";
import { TotemStartForm } from "./TotemStartForm/TotemStartForm";
import { totemStartSchema, TTotemStartFormData } from "./totemStartSchema";

export const colors: ITotemStartColors = {
  primary: "#0044cc",
  secondary: "#00aaff",
  light: "#def1ff",
};

function TotemStart() {
  const environmentOptions = [
    {
      id: "1",
      name: "Produção",
    },
    {
      id: "2",
      name: "Homologação",
    },
    {
      id: "3",
      name: "Desenvolvimento",
    },
  ];

  const methods = useForm<TTotemStartFormData>({
    resolver: zodResolver(totemStartSchema),
    defaultValues: {
      environment: environmentOptions[0],
    },
  });

  const { sendRequest } = useFetch(loginTotem);

  const { handleSubmit } = methods;

  const onSubmitHandler = useCallback(
    async (values: TTotemStartFormData) => {
      const { data, success } = await sendRequest({
        connection: values.environment.id,
        code: values.code,
        password: values.password,
      });

      if (success && data) {
        let browserId = localStorage.getItem("browserId");
        if (!browserId) {
          browserId = crypto.randomUUID();
          localStorage.setItem("browserId", browserId);
        }
        saveTotemDevice({ ...data, code: String(data.code) });
        window.open(`${data.siteApp.siteAppDomains[0].domain}/menu`, "_self");
      }
    },
    [sendRequest]
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(135deg, ${colors.primary}, ${colors.secondary})`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <LanguageChangeNoAuth colors={colors} />

      <Paper
        elevation={5}
        sx={{
          padding: 3,
          borderRadius: "15px",
          width: "80%",
          maxWidth: 410,
          textAlign: "center",
        }}
      >
        <img
          src="/4uTotem.png"
          alt="4uTotem Logo"
          style={{ width: 220, marginBottom: 40 }}
        />
        <Form {...methods}>
          <Box
            component="form"
            autoComplete="off"
            onSubmit={handleSubmit(onSubmitHandler)}
          >
            <TotemStartForm
              environmentOptions={environmentOptions}
              colors={colors}
            />
          </Box>
        </Form>
      </Paper>
      <PlatformFooter width={400} />
    </Box>
  );
}

export default TotemStart;
